var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NuxtLink',{attrs:{"to":`/admind/teams/${_vm.slotParams.item.id}`}},[_vm._v(_vm._s(_vm.slotParams.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }